export default __webpack_public_path__ + "static/media/menu4_hl.36c37327.png";